/**
 * Placeholder constant for collection information used by {@link
 * coreModule.localDraft localDraft}. Each app that uses localDraft
 * should re-define this constant with valid values for it.
 */
export type ILocalDraftCollections = {
  [collectionName: string]: {
    primaryKey: string;
    additionalIndexKeys?: string[];
  };
};

export const LocalDraftCollectionsProvider: {
  provide: string;
  useValue: ILocalDraftCollections;
} = {
  provide: 'localDraftCollections',
  useValue: {
    receivings: { primaryKey: 'id' },
    replenishment: { primaryKey: 'id' },
    salesorders: { primaryKey: '_id', additionalIndexKeys: ['customer._id'] },
  },
};
